<template lang="html">

  <section class="pe_current-clue">

    <button
      @click="selectPrevClue"
      class="pe_btn pe_prev"
    >
      <Arrow />
    </button>

    <span v-html="text"></span>

    <button
      @click="selectNextClue"
      class="pe_btn pe_next"
    >
      <Arrow direction="right" />
    </button>

  </section>

</template>

<script lang="js">

  import { mapState, mapGetters, mapActions } from 'vuex'
  import Arrow from '@puzzleapps/shared/src/components/ui/icons/Arrow'

  export default  {
    name: 'cluelist',
    props: ['initialDirection'], // across, down
    components: {
      Arrow
    },

    data() {
      return {
        direction: this.initialDirection,
      }
    },

    methods: {
      ...mapActions({
        highlightClueOnGrid: 'cluelist/highlightClueOnGrid',
        selectNextClue: 'cluelist/selectNextClue',
        selectPrevClue: 'cluelist/selectPrevClue',
      }),      
    },

    computed: {
      ...mapState({
        isAcross: state => state.grid.isAcross,
        selectedClues: state => state.cluelist.selected,
        selectedCell: state => state.grid.selectedCell,
      }),

      text() {
        let wordLength = null
        let clue = null

        if (this.isAcross && this.selectedClues.across) 
          clue = this.selectedClues.across        
        else if (!this.isAcross && this.selectedClues.down) 
          clue = this.selectedClues.down        
        else 
          return ''        

        return `${ clue.clueNumber }${ clue.direction[0] }. ${ clue.clue }`        
      }
    }
  }
</script>

<style scoped lang="scss">

  @import '@puzzleapps/shared/src/style/variables';

  .pe_current-clue {
    display: flex;
    background: #f5f5f5;
    min-height: 2.8em;
    justify-content: space-between;
    align-items: center;
    font-size: 1.3em;
    position: relative;
    padding: 0;
    border: 1px solid #ececec;
    border-top: 0;
    box-sizing: border-box;
    margin: 0.1em 0.1em;

    span ::v-deep em {
      opacity: 0.8;
    }

    .pe_btn {
      width: 40px;
      height: 40px;
      opacity: 0.9;

      &:hover {
        background: rgba(0,0,0,0.1);
      }
    
      &.pe_prev {
        left: 0;
      }
    
      &.pe_next {
        right: 0;
      }
    }

    // @media (min-width: 600px) {
    //   display: none;
    // }

  }
</style>
